export function getFirstHtmlElement(htmlString: string, selector?: 'h1, h2, h3, h4, h5, h6' | 'p' | 'strong'): string | null {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const heading = doc.querySelector(selector ?? 'h1, h2, h3, h4, h5, h6');
  return heading ? heading.outerHTML : null;
}
